export default __webpack_public_path__ + "c931ae7.png";